// import artTemplate from '../../../static/js/art-template-web';
// import objectUtil from '../../../static/js/objectUtil';
// artTemplate.defaults.escape = false; // 是否编码输出 HTML 字符
// artTemplate.defaults.bail = false; // bail 如果为 true，编译错误与运行时错误都会抛出异常
// artTemplate.defaults.imports.objectUtil = objectUtil;

// var templateUtil = {};
// templateUtil.artTemplate = artTemplate;
// // 特殊转换
// templateUtil.specialConversion = {
//     'true': true,
//     'false': false
// };

// // 递归转换字符串true false 转换为布尔值
// templateUtil.transformBoolean = function (data) {
//     if (typeof data === 'object') {
//         for (var variable in data) {
//             if (typeof data[variable] === 'object') {
//                 templateUtil.transformBoolean(data[variable]);
//             } else {
//                 var compileValue = data[variable];
//                 // 转义boolean 字符串，到boolean类型
//                 if (templateUtil.specialConversion.hasOwnProperty(compileValue)) {
//                     // console.log("specialConversion:compileValue", compileValue);
//                     data[variable] = templateUtil.specialConversion[compileValue];
//                 }
//             }
//         }
//     }
// };

// // 该参参数，不生效，待研究）
// // templateUtil.options = {
// //
// //
// //   // 参数配置参考， https://aui.github.io/art-template/zh-cn/docs/options.html
// //   // artTemplateOptions: {
// //   //   //是否编码输出 HTML 字符
// //   //   escape: false,
// //   //   // bail 如果为 true，编译错误与运行时错误都会抛出异常
// //   //   bail: false
// //   // }
// // };

// /**
// @param sourceData 对象值是模板
// @param data  :{data:data,user:user} 业务数据对象

// return {object} sourceData 编译后

//  "queryParam":{"id":"{{data.id}}","userId":"{{user.id}}"}

//    =》
//    return  "queryParam":{"id":"123","userId":"123"}
// */

// templateUtil.compileData = function (sourceData, data) {
//     if (!sourceData) return sourceData;
//     var returnData = null;
//     var sourceDataString = null;
//     if (typeof sourceData === 'object') {
//         sourceDataString = JSON.stringify(sourceData);
//         if (sourceDataString == '{}') return sourceData;

//         returnData = artTemplate.compile(sourceDataString)(data);

//         if (typeof returnData === 'string') {
//             returnData = JSON.parse(returnData);
//         }
//     } else {
//         sourceDataString = sourceData;
//         returnData = artTemplate.compile(sourceDataString)(data);
//     }

//     templateUtil.transformBoolean(returnData);
//     // if (typeof returnData == 'object') {
//     //   for (var variable in returnData) {
//     //     if(typeof returnData[variable] == 'object'){
//     //
//     //     }
//     //     var compileValue = returnData[variable];
//     //     //转义boolean 字符串，到boolean类型
//     //     if (templateUtil.specialConversion.hasOwnProperty(compileValue)) {
//     //       //console.log("specialConversion:compileValue", compileValue);
//     //       returnData[variable] = templateUtil.specialConversion[compileValue];
//     //     }
//     //   }
//     // }

//     // console.log("compileData：returnData", returnData);
//     // console.log("compileData", sourceDataString, returnData);
//     return returnData;

//     //
//     // var param = {};
//     // for (var variable in sourceData) {
//     //   var str = sourceData[variable];
//     //   if (str && typeof str == 'string') {
//     //     //parm 模板语法，进行翻译
//     //     var compileValue = artTemplate.compile(str)(data);
//     //     //转义特殊数据
//     //     if (templateUtil.specialConversion.hasOwnProperty(compileValue)) {
//     //       compileValue = templateUtil.specialConversion[compileValue];
//     //     }
//     //     param[variable] = compileValue;
//     //   } else {
//     //     param[variable] = str;
//     //   }
//     // }
//     //
//     // return param;
// };

// export default templateUtil;

//模板解析不再使用art-template-web
import templateUtil from '../../../static/js/templateUtil'
export default templateUtil
